export enum ValueEnum {
  TVG4 = "tvg4",
  TVG5 = "tvg5"
}

export interface Props {
  accountNumber: string;
}
